import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.module.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { timeAgo } from "../Marque/time";
// import { Zoom } from "react-reveal";
// import Jump from "react-reveal/Jump";
const Slider = ({ posts }) => {
  const [current, setCurrent] = useState(0);
  const length = posts.length;
  const timeout = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const nextSlider = () => {
      setCurrent((current) => (current === length - 1 ? 0 : current + 1));
    };
    timeout.current = setTimeout(nextSlider, 3000);
    return function () {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
  }, [current, length]);

  const nextSlider = () => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlider = () => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  if (!Array.isArray(posts) || posts.length <= 0) {
    return null;
  }
  const clickHandler = (post) => {
    navigate(`/post/${post._id}`, { state: post });
  };

  const returnCreatedAt = (post) => {
    const someDate = new Date(post?.createdAt);
    return someDate;
  };

  return (
    <div className={styles.carousel}>
      <div className={styles.carouselWrapper}>
        {posts?.map((slide, index) => (
          <div className={styles.carouselSlide} key={index}>
            {index === current && (
              <div
                className={styles.carouselSlider}
                onClick={() => clickHandler(slide)}
              >
                <div className={styles.overlay}></div>
                <img
                  src={slide?.images?.[0]}
                  alt={slide?.title}
                  className={styles.carouselImage}
                />
                <div className={styles.carouselContent}>
                  {/* <Zoom top> */}
                  <h1>
                    {slide?.title?.length > 50
                      ? `${slide?.title?.slice(0, 50)}...`
                      : slide?.title}
                  </h1>
                  <span>{slide?.author}</span>
                  <span>{timeAgo(returnCreatedAt(slide))}</span>
                </div>
              </div>
            )}
          </div>
        ))}
        <div className={styles.carouselControls}>
          <span onClick={prevSlider}>
            <IoIosArrowBack />
          </span>
          <span onClick={nextSlider}>
            <IoIosArrowForward />
          </span>
        </div>
      </div>
    </div>
  );
};

export default Slider;
